import {LeadDto} from './leadDto';
import {Communication} from '../communication';
import {Mail} from '../mail';
import {MailCheck} from '../mailCheck';

export class AddCommunicationRequest {
  newLead: boolean;
  lead: LeadDto;
  communication: Communication;
  mail: Mail;
  mailChecks: MailCheck[];
}
